<app-page-title title="Cadastrar Palavra"></app-page-title>
<div class="form-container">
  <form [formGroup]="formGroup">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Tema da palavra</mat-label>
      <input class="input" matInput placeholder="Tema da palavra" formControlName="theme" />
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Area</mat-label>
      <mat-select #group formControlName="area_id">
        <mat-option *ngFor="let area of areas" [value]="area.id">
          {{ area.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <br />
    <input type="file" (change)="selectFile($event)" />
    <br />
    <br />

    <div *ngIf="uploadProgress > 0">
      <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
      <br />
    </div>
    <button *ngIf="!id" (click)="send()" mat-raised-button class="btn-primary">Cadastrar</button>
    <!--
    <button *ngIf="id" (click)="save()" class="btn-primary" mat-raised-button>
      Salvar
    </button> -->
  </form>
</div>
